export const hi = {
    translation: {
        b: {
            cancel: 'रद्द करें',
            confirm: 'पुष्टि करें',
            send: 'भेजें',
            done: 'सम्पन्न',
            close: 'बंद करें',
            clear: 'साफ़ करें',
            copy_link: 'लिंक कॉपी करें',
            export: 'निर्यात',
            delete: 'हटाएँ',
            delete_confirm: 'हटाने की पुष्टि करें',
            duplicate: 'डुप्लिकेट',
            share: 'साझा करें',
            sign_in: 'साइन इन',
            sign_up: 'साइन अप',
            email_address: 'ईमेल पता',
            yes: 'हाँ',
            no: 'नहीं'
        },
        m_languages: {
            title: 'भाषाएँ',
            subtitle: 'कोई भाषा चुनें'
        },
        m_feedback: {
            feature: {
                name: 'फ़ीचर अनुरोध',
                desc: 'क्या कोई फ़ीचर नहीं मिल रहा? हमें बताइए — आपके सुझाव महत्वपूर्ण हैं'
            },
            feedback: {
                name: 'प्रतिक्रिया',
                desc: 'आपकी प्रतिक्रिया हमारे लिए बहुत मायने रखती है — एक छोटा सा संदेश छोड़ दें'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'आपके सुझाव के लिए धन्यवाद!',
                desc: 'अपना विचार साझा करने के लिए समय निकालने हेतु धन्यवाद — इससे हमें चीज़ों को बेहतर बनाने में मदद मिलती है।'
            },
            feedback: {
                name: 'आपकी प्रतिक्रिया के लिए धन्यवाद!',
                desc: 'अपना विचार साझा करने के लिए समय निकालने हेतु धन्यवाद — इससे हमें चीज़ों को बेहतर बनाने में मदद मिलती है।'
            }
        },
        m_diagram_details: {
            name_place: 'प्रोजेक्ट का नाम दर्ज करें',
            desc_place: 'प्रोजेक्ट का विवरण दर्ज करें'
        },
        m_quick_share: {
            title: 'त्वरित साझा करें',
            subtitle: '(क्वेरी-आधारित लिंक शेयरिंग)'
        },
        m_export_img: {
            title: 'छवि निर्यात करें'
        },
        m_export_code: {
            title: 'कोड {{db_engine}} निर्यात करें',
            download_file: 'फ़ाइल डाउनलोड करें',
            copy_code: 'कोड कॉपी करें'
        },
        m_sign_in_remind: {
            title: 'DB Design आज़माने के लिए धन्यवाद',
            subtitle: 'टेबलों की अधिकतम संख्या बढ़ाने, डायग्राम सहेजने और अधिक फ़ीचर अनलॉक करने के लिए साइन इन या साइन अप करें।'
        },
        m_sign_in_restrict: {
            title: 'ऐप में अधिक करने के लिए साइन इन करें',
            subtitle: 'टेबल सीमाएँ बढ़ाने, डायग्राम सहेजने और अधिक फ़ीचर अनलॉक करने के लिए साइन इन या साइन अप करें।'
        },
        m_new_diagram: {
            title: 'नया डायग्राम',
            subtitle: 'कोई डेटाबेस इंजन चुनें',
            open_diagram: 'डायग्राम खोलें'
        },
        m_keyboard_shortcuts: {
            title: 'कीबोर्ड शॉर्टकट',
            ctrl_left: {
                title1: 'नियंत्रण',
                title2: '(बाएँ)',
                items: {
                    mouse_sel: 'माउस चयन / हैंड मोड',
                    table: 'टेबल',
                    line: 'रेखा',
                    area: 'क्षेत्र',
                    note: 'नोट',
                    comment: 'टिप्पणी',
                    pen: 'पेंसिल',
                    undo: 'पूर्ववत्',
                    redo: 'दोहराएँ'
                }
            },
            ctrl_top_left: {
                title1: 'नियंत्रण',
                title2: '(ऊपर-बाएँ)',
                items: {
                    export_img: 'छवि निर्यात करें',
                    search: 'खोजें',
                    editor_panel: 'एडिटर पैनल'
                }
            },
            ctrl_bottom_right: {
                title1: 'नियंत्रण',
                title2: '(नीचे-दाएँ)',
                items: {
                    minimap: 'मिनिमैप',
                    zoom_in: 'ज़ूम इन',
                    zoom_out: 'ज़ूम आउट',
                    zoom_100: '100% पर ज़ूम'
                }
            },
            ctx_tab: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल)',
                items: {
                    dupl_tab: 'टेबल डुप्लिकेट करें',
                    del_tab: 'टेबल हटाएँ'
                }
            },
            ctx_del_tab: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल हटाएँ)',
                items: {
                    yes: 'हाँ',
                    no: 'नहीं'
                }
            },
            ctx_tab_col: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल कॉलम)',
                items: {
                    add_col_below: 'नीचे नया कॉलम जोड़ें',
                    focus_col_above: 'ऊपर वाले कॉलम पर फोकस',
                    focus_col_below: 'नीचे वाले कॉलम पर फोकस',
                    move_col_up: 'कॉलम ऊपर ले जाएँ',
                    move_col_down: 'कॉलम नीचे ले जाएँ',
                    dupl_col: 'कॉलम डुप्लिकेट करें',
                    del_col: 'कॉलम हटाएँ'
                }
            },
            ctx_line: {
                title1: 'प्रासंगिक मेनू',
                title2: '(रेखा)',
                items: {
                    del_line: 'रेखा हटाएँ'
                }
            },
            ctx_area: {
                title1: 'प्रासंगिक मेनू',
                title2: '(क्षेत्र)',
                items: {
                    dupl_area: 'क्षेत्र डुप्लिकेट करें',
                    del_area: 'क्षेत्र हटाएँ'
                }
            },
            ctx_multi: {
                title1: 'प्रासंगिक मेनू',
                title2: '(मल्टीसेलेक्ट)',
                items: {
                    select_all: 'सभी तत्व चुनें',
                    create_area_for_select_els: 'चयनित तत्वों के लिए क्षेत्र बनाएँ',
                    dupl_select_els: 'चयनित तत्व डुप्लिकेट करें',
                    del_select_els: 'चयनित तत्व हटाएँ'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'माउस चयन',
                table: 'टेबल',
                line: 'रेखा',
                area: 'क्षेत्र',
                note: 'नोट (जल्द)',
                comment: 'टिप्पणी (जल्द)',
                pen: 'पेंसिल',
                undo: 'पूर्ववत्',
                redo: 'दोहराएँ'
            },
            ctrl_top_left: {
                logo: 'नोट: यह एक सैंडबॉक्स (परीक्षण परिवेश) है',
                name: 'डायग्राम जानकारी',
                editor: 'एडिटर (जल्द)',
                search: 'खोज (जल्द)',
                export: 'निर्यात विकल्प',
                view_mode: 'दृश्य मोड',
                zoom_to_fit: 'स्क्रीन के अनुसार फिट करें'
            },
            ctrl_top_right: {
                feature_req: 'फ़ीचर अनुरोध',
                sign_in: 'साइन इन',
                quick_share: 'त्वरित साझा'
            },
            ctrl_bottom_right: {
                full_screen: 'पूर्ण स्क्रीन',
                minimap: 'मिनिमैप',
                zoom_out: 'ज़ूम आउट',
                zoom_100: '100% पर ज़ूम',
                zoom_in: 'ज़ूम इन',
                info: 'जानकारी व संसाधन'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'डिफ़ॉल्ट',
                        blue: 'नीला',
                        green: 'हरा',
                        red: 'लाल',
                        purple: 'बैंगनी',
                        violet: 'वायलेट'
                    },
                    borders: {
                        none: 'कोई नहीं',
                        solid: 'सॉलिड',
                        dashed: 'डैश्ड',
                        dotted: 'डॉटेड'
                    },
                    color: 'रंग',
                    border: 'बॉर्डर',
                    description: 'विवरण',
                    description_table_place: 'तालिका का विवरण',
                    description_column_place: 'कॉलम का विवरण',
                    description_line_place: 'रेखा का विवरण',
                    description_note_place: 'नोट का विवरण',
                    description_area_place: 'क्षेत्र का विवरण',
                    description_pen_place: 'पेंसिल का विवरण',
                    hide_menu: 'मेनू छिपाएँ',
                    show_menu: 'मेनू दिखाएँ'
                },
                tab_col: {
                    add_col_below: 'नीचे कॉलम जोड़ें',
                    add_col_above: 'ऊपर कॉलम जोड़ें',
                    key: 'Key',
                    keys: {
                        none: 'कोई नहीं',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'कोई नहीं',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'कॉलम नीचे ले जाएँ',
                    move_col_up: 'कॉलम ऊपर ले जाएँ',
                    more_functions: 'अधिक फ़ंक्शन'
                },
                line: {
                    change_connects: 'कनेक्टर्स बदलें',
                    connects: {
                        empty: 'खाली',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'तत्व फ़िल्टर करें'
                },
                multi: {
                    filter: 'चयन फ़िल्टर करें',
                    create_area: 'क्षेत्र बनाएँ'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'पूर्ण',
            keys_only: 'केवल कुंजियाँ',
            names_only: 'केवल नाम'
        },
        dropdown_ctrl_export: {
            export_img: 'छवि निर्यात करें',
            export_code: 'SQL कोड निर्यात करें'
        },
        dropdown_ctrl_settings: {
            sign_in: 'साइन इन',
            new_project: 'नया प्रोजेक्ट',
            keyboard_shortcuts: 'कीबोर्ड शॉर्टकट',
            languages: 'भाषाएँ'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'प्रतिक्रिया',
            keyboard_shortcuts: 'कीबोर्ड शॉर्टकट',
            languages: 'भाषाएँ',
            homepage: 'मुखपृष्ठ'
        },
        n: {
            default: 'लोड हो रहा है…',
            file_ready_to_download: 'फ़ाइल डाउनलोड के लिए तैयार है',
            code_copied: 'कोड कॉपी कर दिया गया है',
            link_copied: 'लिंक कॉपी कर दिया गया है',
            please_enter_message: 'कृपया संदेश दर्ज करें',
            invalid_email: 'ईमेल पता मान्य नहीं है',
            something_wrong_contact: 'कुछ गड़बड़ हो गई। कृपया पृष्ठ रीलोड करें या हमसे संपर्क करें।',
            something_wrong: 'कुछ गड़बड़ हो गई। कृपया पृष्ठ रीलोड करें',
            sending: 'भेजा जा रहा है…',
            request_sent: 'अनुरोध भेज दिया गया है। धन्यवाद!'
        }
    }
};

export const hiMeta = {
    lang_origin: 'हिंदी',
    lang_eng: 'Hindi',
    lang_code: 'hi',
};
